export default "/profile/images/Odoo.svg?794bdc9b9405daf5239a21f4eaf8d83a";